import api from './api';

const ENDPOINT = 'sales';

const SaleService = {
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  getByClient: (params) => api.get(`${ENDPOINT}/get-by-client`, { params }),
};

export default SaleService;
